import { HostListener, Directive } from '@angular/core';
import { Observable } from 'rxjs';

@Directive()
export abstract class CanDeactivateBase {
  abstract canDeactivate(): Observable<boolean>;

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification(
    $event: any // eslint-disable-line @typescript-eslint/no-explicit-any
  ) {
    this.canDeactivate().subscribe(res => {
      if (!res) {
        $event.returnValue = true;
      }
    });
  }
}

export interface ICanDeactivateBase {
  canDeactivate(): Observable<boolean>;
}
